import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { PurchaseInquiryPopup } from './PurchaseInquiryTable';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import { decryptAES } from '../../../utils/Encryption';
import moment from 'moment';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class PurchaseInquiry extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.transactionStockServices = new TransactionStockServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            globalUserID: '',
            usp_Users: [],
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            itemRowData: [],
            itemColDefs: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            purchaseObject: {
                idPurchaseInquiry: 0,
                updateStatus: 0,
                piNo: '',
                piDate: '',
                idEmployee: 0,
                EmployeeList: [],
                idWorkOrder: 0,
                workOrderList: [],
                prefix: 0,
                e_Date: '',
                deleteItemsList: [],
            },
            itemObject: {
                keyId: 0,
                drawingNo: '',
                idType: 1,
                itemType: "",
                idItem: 0,
                //itemName: '',
                ItemList: [],
                quantity: 0,
                remarks: '',
                idIndentRegisterItems: 0,
                idIndentRegister: 0,
                idPurchaseInquiryItems: 0,
                utStatus: 0,
                idMaterialPlanning: 0,
                idMaterialPlanningDetails: 0,
                TypeList: [
                    {
                        value: 1,
                        label: "RAW MATERIAL"
                    },
                    {
                        value: 2,
                        label: "FINISHED GOODS"
                    },
                    {
                        value: 3,
                        label: "SEMI FINISHED"
                    },
                    {
                        value: 4,
                        label: "SCRAP MATERIAL"
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForPurchase: {
                idWorkOrder: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "work order"
                        ),
                    },
                ],
            },
            validationRulesForItem: {
                idItem: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item"
                        ),
                    },
                ],
            },
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetDetailsFields();
        this.resetItemDetails();
        this.setState({ isModalOpen: true, itemRowData: [] }, () => {
            this.getPrefixSelectPrefix();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.usp_Transaction_PurchaseInquirySelectbyId(event.data.idPurchaseInquiry);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    handleCellClick = (event) => {
        this.procSelectAllRecord2GridviewSP(event.data.idPurchaseInquiry);
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForRegister = () => {
        const newValidState = isValidForm(
            this.state.registerObject,
            this.state.validationRulesForPurchase,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }
    isValidAllFieldsForItem = () => {
        const newValidState = isValidForm(
            this.state.itemObject,
            this.state.validationRulesForItem,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChangeForPurchase = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.purchaseObject;
        details[name] = value;
        this.setState({ purchaseObject: details });
    }
    handleChangeForItem = (event, name) => {
        let value = event.target.value;
        let details = this.state.itemObject;
        details[name] = value;
        this.setState({ itemObject: details });
    }

    handleChangeForDropdown = (event, name, field) => {
        let details = this.state.purchaseObject;
        let details1 = this.state.itemObject
        let value = event.value;
        if (field === 'purchaseObject') {
            details[name] = value;
            this.setState({ purchaseObject: details });
        } else {
            details1[name] = value;
            this.setState({ itemObject: details1 }, () => {
                if (name === 'idType') {
                    var itemName = this.state.itemObject.TypeList.find(x => x.value === this.state.itemObject.idType)?.label;
                    this.getMaster_ItemSelectbyItemType(itemName);
                }
                if (name === 'idItem') {
                    this.getMaster_ItemSelectbyID(this.state.itemObject.idItem);
                }
            });
        }
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let object = this.state.purchaseObject
        object.idPurchaseInquiry = 0
        object.updateStatus = 0
        object.piNo = ''
        object.piDate = ''
        object.idEmployee = 0
        object.idWorkOrder = 0
        object.prefix = 0

        this.setState({
            validState: validState,
            purchaseObject: object
        });
    }

    handleCellClickItemList = (event) => {
        //this.getMasterChequeBookSelectbyId(event.data.idChequeBookMaster);
        //let validState = this.state.validState;
        //validState.isValid = true;
        //validState.error = {};
        let itemData = this.state.itemRowData[event.data.keyId - 1];
        let data = this.state.itemObject;
        data.keyId = itemData.keyId;
        data.drawingNo = itemData.drawingNo;
        data.itemType = itemData.itemType;
        data.idType = data.TypeList?.find(x => x.label === itemData.itemType)?.value;
        data.idItem = itemData.idItem;
        //data.ItemList = [];
        data.quantity = itemData.quantity;
        data.remarks = itemData.remarks;
        data.idIndentRegisterItems = itemData.idIndentRegisterItems;
        data.idIndentRegister = itemData.idIndentRegister;
        data.idPurchaseInquiryItems = itemData.idPurchaseInquiryItems;
        data.utStatus = itemData.utStatus;
        data.idMaterialPlanning = itemData.idMaterialPlanning;
        data.idMaterialPlanningDetails = itemData.idMaterialPlanningDetails;
        this.setState({ itemObject: data }, () => {
            this.getMaster_ItemSelectbyItemType(this.state.itemObject.itemType);
        });

        // obj.id = data.id;
        // obj.chequeBookNo = data.chequeBookNo;
        // obj.isCancel = data.isCancel;
        // obj.remarks = data.remarks;
        // obj.idChequeBookDetails = data.idChequeBookDetails;
        // this.setState({
        //     itemObject: obj,
        //     isModalOpenForAddItem: true,
        // });
    };

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName, globalUserID: prop.globalUserID }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Transaction_WorkOrderRecvSelectForPurchaseInquiry();
                this.usp_GetAllUsers();
            });
        }
    }

    usp_GetAllUsers = () => {
        this.accountTransactionServices.usp_GetAllUsers().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    this.setState({
                        usp_Users: data,
                    });
                }
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Purchasing Inquiry",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            width: this.getPinnedColumnWidth(key) !== undefined ? this.getPinnedColumnWidth(key) : window.innerWidth * 0.05,
                            //pinned: ["sR.No", "jobWorkNo", "jobWorkInwardDate", "jobWorkFrom", "invoiceNo"].includes(key) ? "left" : undefined,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idPurchaseInquiry"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Purchasing Inquiry",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id);
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            // "invoiceDate": window.innerWidth * 0.08,
            // "vendor": window.innerWidth * 0.2,
            // "gatePassNo": window.innerWidth * 0.06,
            // "totalQty": window.innerWidth * 0.06,
            // "totalAmt": window.innerWidth * 0.06,
            // "extraCharges": window.innerWidth * 0.06,
            // "discount": window.innerWidth * 0.06,
            // "taxAmt": window.innerWidth * 0.06,
            // "finalAmt": window.innerWidth * 0.06,
            // "approvalStatus": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }
    getPinnedColumnWidth = (key) => {
        const colwidth = {
            // "sR.No": window.innerWidth * 0.05,
            // "jobWorkNo": window.innerWidth * 0.09,
            // "jobWorkInwardDate": window.innerWidth * 0.08,
            // "jobWorkFrom": window.innerWidth * 0.08,
            // "invoiceNo": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id) => {
        let request = {
            id: id,
            formname: "Purchase Inquiry",
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    getColumnWidth2 = (key) => {
        const colwidth = {
            // "drawingNo": window.innerWidth * 0.11,
            // "itemCategory": window.innerWidth * 0.16,
            // "itemName": window.innerWidth * 0.2,
            // "hsnCode": window.innerWidth * 0.06,
            // "quantity": window.innerWidth * 0.06,
            // "rate": window.innerWidth * 0.06,
            // "taxableAmt": window.innerWidth * 0.06,
            // "sgst": window.innerWidth * 0.04,
            // "sgstAmt": window.innerWidth * 0.06,
            // "cgst": window.innerWidth * 0.04,
            // "cgstAmt": window.innerWidth * 0.06,
            // "igst": window.innerWidth * 0.04,
            // "igstAmt": window.innerWidth * 0.06,
            // "netTotal": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }

    getPrefixSelectPrefix = () => {
        let request = {
            formname: "FrmTransactionPurchaseInquiry",
            idCompany: this.state.idCompany,
            idCompanyDivision: 0,
        };
        this.accountTransactionServices.getPrefixSelectPrefix(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0];
                let dt = this.state.purchaseObject;
                if (data) {
                    dt.prefix = data.prefix;
                }
                this.setState({ purchaseObject: dt }, () => {
                    this.getNoCount();
                });
            } else {
                this.getNoCount();
            }
        });
    }

    getNoCount = () => {
        // this.accountTransactionServices.getInwardNoCount(request).then((response) => {
        //     if (response.statusCode == 200 && response.responseItem !== null) {
        //         let data = response.responseItem.responseContent;
        //debugger;
        let details = this.state.purchaseObject;
        let maxIdPaymentMake = this.state.rowData.length > 0
            ? this.state.rowData.length
            : 0;
        let inwardNo = String(maxIdPaymentMake + 1).padStart(3, '0');
        details.piNo = details.prefix + inwardNo;
        details.piDate = moment(new Date()).format('YYYY-MM-DD');
        this.setState({ purchaseObject: details }, () => {
            //this.getNetworkConfiguration();
        })
        //     }
        // });
    }

    usp_Transaction_WorkOrderRecvSelectForPurchaseInquiry = () => {
        let request = [
            this.state.idCompany,
            this.state.purchaseObject.idPurchaseInquiry,
            this.state.purchaseObject.updateStatus
        ];
        this.transactionStockServices.usp_Transaction_WorkOrderRecvSelectForPurchaseInquiry(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent[0];
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idwoOrderRecv,
                        label: x.woRecvNo + ' - ' + x.partyACName,
                        //partyAddress: x.p_Address
                    }));
                    let obj = this.state.purchaseObject;
                    obj.workOrderList = dynamicData;
                    obj.idWorkOrder = obj.idWorkOrder;
                    this.setState({ materialObject: obj }, () => {
                        this.getMaster_ItemSelectbyItemType('RAW MATERIAL', "itemTypeId2");
                    }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                    this.getMaster_ItemSelectbyItemType('RAW MATERIAL');
                }
            }
        });
    }

    getMaster_ItemSelectbyItemType = (label) => {
        let request = [label, this.state.idCompany];
        this.masterEntryServices.getMaster_ItemSelectbyItemType(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                let itemObject = this.state.itemObject;
                data = data.map((x) => ({
                    value: x.idItem,
                    label: x.itemCategory + ' - ' + x.itemName + ' - ' + x.drawingNo + ' - ' + x.searchText,
                    itemName: x.itemName
                }));

                // if (name === 'itemTypeId2') {
                //     itemObject.ItemList = data;
                //     itemObject.itemId2 = "";
                // } else if (name === 'itemTypeId') {
                itemObject.ItemList = data;
                itemObject.idItem = itemObject.idItem;
                //}
                this.setState({
                    itemObject: itemObject,
                });
            }
        });
    }

    getMaster_ItemSelectbyID = (id) => {
        this.masterEntryServices.getItemMasterSelectbyID(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0];
                let itemObject = this.state.itemObject;
                itemObject.drawingNo = data.drawingNo;
                //itemObject.itemTypeId2 = data.itemType ? itemObject.TypeList.find(x => x.label === data.itemType).value : 0;
                this.setState({
                    itemObject: itemObject,
                });
            }
        });
    }


    insert = (isFor) => {
        if (this.state.itemObject.idItem > 0 && Number(this.state.itemObject.quantity) > 0) {

            let itemObject = this.state.itemObject;
            let itemListRowData = [...this.state.itemRowData];
            //res.itemList?.map((x) => {
            let object = {
                // type: itemObject.types?.find(x => x.value === itemObject.itemTypeId2)?.label,
                // drawingNo: itemObject.drawingNo,
                // //itemDetails: itemObject.itemId2Label,
                // //idItem: itemObject.itemId2,
                // quantity: Number(itemObject.quantity),
                drawingNo: itemObject.drawingNo,
                idType: itemObject.idType,
                itemType: itemObject.TypeList?.find(x => x.value === itemObject.idType)?.label,
                idItem: itemObject.idItem,
                itemName: itemObject.ItemList?.find(x => x.value === itemObject.idItem)?.itemName,
                //ItemList: [],
                quantity: Number(itemObject.quantity),
                remarks: itemObject.remarks,

                idIndentRegisterItems: itemObject.idIndentRegisterItems,
                idIndentRegister: itemObject.idIndentRegister,
                idPurchaseInquiryItems: itemObject.idPurchaseInquiryItems,
                utStatus: itemObject.utStatus,
                idMaterialPlanning: itemObject.idMaterialPlanning,
                idMaterialPlanningDetails: itemObject.idMaterialPlanningDetails
            }
            //itemListRowData.push(object);
            //});
            if (isFor === "Update") {
                itemListRowData[itemObject.keyId - 1] = object;
            } else {
                itemListRowData.push(object);
            }
            //itemObject.processRowData = [...itemListRowData];
            itemListRowData.map((x, key) => {
                x.keyId = key + 1;
            })
            this.setState({
                itemRowData: itemListRowData,
            }, () => {
                this.resetItemDetails()
            });
        }
    }

    resetItemDetails = () => {
        let data = this.state.itemObject;
        data.keyId = 0;
        data.drawingNo = '';
        //data.idType = ;
        data.idItem = 0;
        //data.ItemList = [];
        data.quantity = '';
        data.remarks = '';
        data.idIndentRegisterItems = 0;
        data.idIndentRegister = 0;
        data.idPurchaseInquiryItems = 0;
        data.utStatus = 0;
        data.idMaterialPlanning = 0;
        data.idMaterialPlanningDetails = 0;
        this.setState({ itemObject: data });
    }

    resetpurchaseObjectDetails = () => {
        let data = this.state.purchaseObject;
        data.idPurchaseInquiry = 0;
        data.updateStatus = 0;
        data.piNo = '';
        data.piDate = '';
        data.idEmployee = 0;
        data.EmployeeList = [];
        data.idWorkOrder = 0;
        //data.workOrderList = [];
        data.prefix = 0;
        data.e_Date = '';
        data.deleteItemsList = [];
        this.setState({ purchaseObject: data });
    }

    // clear = (keyId) => {
    //     //const itemObject = { ...this.state.itemObject };
    //     const itemListRowData = [...this.state.itemObject];
    //     itemListRowData.splice(keyId - 1, 1);
    //     //itemObject.processRowData = itemListRowData;
    //     this.setState({ itemObject: itemListRowData });
    // }


    generate = () => {
        if (this.state.purchaseObject.idWorkOrder > 0) {
            let request = [this.state.purchaseObject.idWorkOrder];
            this.transactionStockServices.usp_Transaction_MaterialPlanningSelectbyIDWorkOrder_ForPurchaseInquiry(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    let itemListRowData = this.state.itemRowData;
                    // itemObject.drawingNo = data.drawingNo;
                    //let itemObject = this.state.itemObject;
                    itemListRowData = [];
                    data.map((x) => {
                        let object = {}; // this.state.itemObject;
                        //object.keyId = 0;
                        object.drawingNo = x.drawingNo;
                        object.itemType = x.itemType;
                        object.idType = this.state.itemObject.TypeList.find(f => f.label === x.itemType)?.value;
                        object.idItem = x.idItem;
                        object.itemName = x.itemName;
                        //object.ItemList = [];
                        object.quantity = x.piQuantity;
                        object.remarks = x.remarks ? x.remarks : "";

                        object.idIndentRegisterItems = x.idIndentRegisterItems ? x.idIndentRegisterItems : 0;
                        object.idIndentRegister = x.idIndentRegister ? x.idIndentRegister : 0;
                        object.idPurchaseInquiryItems = x.idPurchaseInquiryItems ? x.idPurchaseInquiryItems : 0;
                        object.utStatus = x.utStatus ? x.utStatus : 0;
                        object.idMaterialPlanning = x.idMaterialPlanning ? x.idMaterialPlanning : 0;
                        object.idMaterialPlanningDetails = x.idMaterialPlanningDetails ? x.idMaterialPlanningDetails : 0;

                        itemListRowData.push(object);
                    });
                    itemListRowData.map((x, key) => {
                        x.keyId = key + 1;
                    })
                    this.setState({ itemRowData: itemListRowData });
                }
            });
        }
    }

    submit = () => {
        if (this.isSubmitting) {
            return;
        }
        //const isValidAllFields = this.isValidAllFields();
        //if (isValidAllFields) {
        if (this.state.itemRowData.length === 0) {
            this.SwalServices.Error("Please add item details.");
        } else {
            let details = this.state.purchaseObject;
            let requestData = {
                // type: details.BOMFromList?.find(x => x.value === details.BOMFromId)?.label,
                // idOldBom: details.oldProductID,
                // idProductReceipe: details.idProductReceipe,
                // idProduct: details.itemId,
                // productType: details.types?.find(x => x.value === details.itemTypeId)?.label,
                // isProduct: 0,
                // isItem: 1,
                idPurchaseInquiry: details.idPurchaseInquiry,
                updateStatus: details.updateStatus,
                inquiryNo: details.piNo,
                inquiryDate: details.piDate,
                authEmployee: details.idEmployee,
                idWOOrderRecv: details.idWorkOrder,
                idWOOrderRecvItems: 0,
                e_Date: details.e_Date && details.e_Date !== 'Invalid date' ? moment(details.e_Date).format('YYYY-MM-DD') : new Date().toISOString(),
                e_IDUser: this.state.idUser,
                isUpdated: details.updateStatus === 1 ? true : null,
                updatedDate: details.updateStatus === 1 ? new Date().toISOString() : null,
                u_IDUser: details.updateStatus === 1 ? this.state.idUser : null,
                idCompany: this.state.idCompany,
                allowSign: null,
                prefix: details.prefix,
                idMaterialPlanning: details.idPurchaseInquiry,
                itemList: [],
                deleteItemsList: details.deleteItemsList,
            };
            this.state.itemRowData.map((x) => {
                let obj = {
                    //idPurchaseInquiry: null,
                    drawingNo: x.drawingNo,
                    itemType: x.itemType,
                    idItem: x.idItem,
                    quantity: x.quantity,
                    idIndentRegisterItems: x.idIndentRegisterItems,
                    idIndentRegister: x.idIndentRegister,
                    itemRemarks: x.remarks,
                    idPurchaseInquiryItems: x.idPurchaseInquiryItems,
                    utStatus: x.utStatus,
                    idMaterialPlanning: x.idMaterialPlanning,
                    idMaterialPlanningDetails: x.idMaterialPlanningDetails
                }
                requestData.itemList.push(obj);
            });
            this.isSubmitting = true;
            this.setState({ isSaving: true });
            this.transactionStockServices.usp_Transaction_PurchaseInquiryInsertUpdate(requestData)
                .then((response) => {
                    if (response.statusCode === 200 && response.responseItem !== null) {
                        let dynamicData = response.responseItem.responseContent;
                        if (dynamicData !== null) {
                            if (dynamicData.errorType === 'Exists') {
                                this.SwalServices.Warning(dynamicData.errorMessage);
                            } else {
                                if (this.state.purchaseObject.updateStatus === 1) {
                                    this.SwalServices.Success("Updated successfully.");
                                } else {
                                    this.SwalServices.Success("Saved successfully.");
                                }
                                this.resetDetailsFields();
                                this.resetItemDetails();
                                this.resetpurchaseObjectDetails();
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.procSelectAllRecordsSP();
                                    }
                                );
                            }
                        } else {
                            this.procSelectAllRecordsSP();
                        }
                    } else {
                        this.setState(
                            { isModalOpen: false },
                            () => {
                                this.SwalServices.Error(response.message);
                                this.procSelectAllRecordsSP(); // Fetch latest records
                            }
                        );
                    }
                }).finally(() => {
                    this.isSubmitting = false;
                    this.setState({ isSaving: false });
                });
        }
    }

    usp_Transaction_PurchaseInquirySelectbyId = (id) => {
        if (id > 0) {
            this.transactionStockServices.usp_Transaction_PurchaseInquirySelectbyId(id).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0][0];
                    let res2 = response.responseItem.responseContent[1];

                    let itemObject = this.state.purchaseObject;

                    itemObject.idPurchaseInquiry = res.idPurchaseInquiry;
                    itemObject.piNo = res.inquiryNo;
                    itemObject.piDate = res.inquiryDate ? moment(res.inquiryDate).format('YYYY-MM-DD') : '';
                    itemObject.idEmployee = res.authEmployee;
                    itemObject.idWorkOrder = res.idwoOrderRecv ?? 0;
                    itemObject.updateStatus = 1;
                    itemObject.e_Date = res.e_Date ?? "";

                    let itemListRowData = [];
                    res2?.map((x) => {
                        let object = {
                            drawingNo: x.itemDrawingNo,
                            itemType: x.itemItemType,
                            idItem: x.idItem,
                            itemName: x.itemName,
                            quantity: x.quantity,
                            idIndentRegisterItems: x.idIndentRegisterItems ? x.idIndentRegisterItems : 0,
                            idIndentRegister: x.idIndentRegister ? x.idIndentRegister : 0,
                            remarks: x.itemRemarks ? x.itemRemarks : "",
                            idPurchaseInquiryItems: x.idPurchaseInquiryItems ? x.idPurchaseInquiryItems : 0,
                            idMaterialPlanningDetails: x.idMaterialPlanningDetails ? x.idMaterialPlanningDetails : 0,
                            utStatus: 1,
                            idMaterialPlanning: x.idMaterialPlanning ? x.idMaterialPlanning : 0,
                        };
                        itemListRowData.push(object);
                    });
                    itemListRowData?.map((x, key) => {
                        x.keyId = key + 1;
                    });

                    this.setState({
                        purchaseObject: itemObject,
                        itemRowData: itemListRowData,
                        isModalOpen: true,
                        globalUserID: res.modifiedBy
                    }, () => {
                        this.usp_Transaction_WorkOrderRecvSelectForPurchaseInquiry();
                    });
                    // let responseWorkOrderList = this.transactionStockServices
                    //     .usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning(requestWorkOrderList);

                    // if (responseWorkOrderList.statusCode == 200 && responseWorkOrderList.responseItem !== null) {
                    //     let resDropdown = responseWorkOrderList.responseItem.responseContent;
                    //     if (resDropdown.length > 0) {
                    //         resDropdown = resDropdown.map((x) => ({
                    //             value: x.idwoOrderRecv,
                    //             label: x.woRecvNo + " - " + x.priority,
                    //         }));
                    //         obj.workOrderList = resDropdown;
                    //     }
                    // }
                }
            });
        }
    };

    deleteItem = (keyId) => {
        let data = this.state.purchaseObject;
        let idPurchaseInquiryItems = this.state.itemRowData?.find(item => item.keyId == keyId)?.idPurchaseInquiryItems;
        let filterData = this.state.itemRowData?.filter(item => item.keyId !== keyId);
        if (filterData.length > 0) {
            filterData.map((x, key) => {
                x.keyId = key + 1;
            });
        }
        //data.itemList = filterData;
        if (idPurchaseInquiryItems > 0) {
            data.deleteItemsList.push(idPurchaseInquiryItems);
        }
        this.setState({ purchaseObject: { ...data }, itemRowData: filterData }, () => {
            this.resetItemDetails();
            //this.finalCalculation();
        });
    }

    render() {
        return (
            <div className='purchase-inquiry'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <PurchaseInquiryPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            purchaseObject={this.state.purchaseObject}
                            itemObject={this.state.itemObject}
                            handleChangeForPurchase={this.handleChangeForPurchase.bind(this)}
                            handleChangeForItem={this.handleChangeForItem.bind(this)}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            itemColDefs={this.state.itemColDefs}
                            insert={this.insert.bind(this)}
                            deleteItem={this.deleteItem.bind(this)}
                            generate={this.generate.bind(this)}
                            handleCellClickItemList={this.handleCellClickItemList.bind(this)}
                            usp_Users={this.state.usp_Users}
                            globalUserID={this.state.globalUserID}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Purchase inquiry</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    onCellClicked={this.handleCellClick}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
